const path = require('path')

const isDevelopment = process.env.NODE_ENV === 'development'

module.exports = {
  i18n: {
    defaultLocale: 'en-US',
    locales: ['en-US', 'de', 'fr', 'es', 'it', 'pt', 'ja', 'nl', 'ko', 'ar'],
    localePath: isDevelopment
      ? path.resolve(process.env.NX_WORKSPACE_ROOT, './applications/templates-website/public/static/locales')
      : path.resolve('./applications/templates-website/public/static/locales'),
  },
}
